// AI Usage — 71_AiUsage.jsx (Jay task #1179, 03/11). Feature names are plain words; codes (Catchy, AI Hub, SCT, GCC) stay as written.
const en = {
  nav: "AI Usage",
  title: "AI Usage",
  sub: "What the portal's AI costs, who and what uses it, and how close today is to the cap. Admin only.",
  env_production: "Production",
  env_staging: "Staging (test)",
  env_all: "Both servers",
  todayTitle: "Today",
  capLine: "USD {{spent}} of {{cap}} — {{pct}}%",
  resetIn: "Resets in {{h}} h {{m}} min (00:00 Vietnam time)",
  peopleCap: "Whole organization",
  systemCap: "Portal's own jobs (reports, summaries)",
  stopsAt: "At the cap, AI stops for everybody until midnight; the jobs keep their own budget.",
  cardMonth: "This month",
  cardVsLast: "vs last month to the same day: {{v}}",
  cardLastMonth: "Last month: USD {{v}}",
  cardQuestions: "Questions asked this month",
  cardQVs: "last month to the same day: {{v}}",
  cardToday: "Calls today",
  personToday: "Each person today",
  colPerson: "Person",
  colEntity: "Entity",
  colDept: "Department",
  colToday: "Today",
  colOwnCap: "Own cap",
  colCalls: "Calls",
  colDeep: "Deeper analysis",
  deepUsed: "{{n}} of {{limit}}",
  deepAdmin: "{{n}} · no limit",
  noneToday: "Nobody has used AI today.",
  trendTitle: "Daily spend",
  capRef: "Daily cap",
  period: "Period",
  p_today: "Today",
  p_week: "This week",
  p_month: "This month",
  p_last: "Last month",
  p_custom: "Custom",
  dfrom: "From",
  dto: "To",
  fEntity: "Entity",
  fDept: "Department",
  fPerson: "Person",
  fFeature: "Feature",
  fModel: "Model",
  all: "All",
  clear: "Clear filters",
  system: "SYSTEM (portal jobs)",
  groupBy: "Group by",
  g_person: "Person",
  g_entity: "Entity",
  g_dept: "Department",
  g_feature: "Feature",
  g_model: "Model",
  g_day: "Day",
  colName: "Name",
  colTin: "Tokens in",
  colTout: "Tokens out",
  colUsd: "USD",
  colShare: "Share",
  total: "Total",
  noRows: "No AI use in this period.",
  settings: "Settings — caps, model prices, API keys",
  capsTitle: "Daily caps",
  capUsers: "Whole organization (USD)",
  capPerson: "Per person (USD)",
  capSystem: "Portal jobs (USD)",
  capOpus: "Deeper analyses a person a day",
  save: "Save",
  saved: "Saved",
  pricesTitle: "Model prices (USD per million tokens)",
  pModel: "Model",
  pIn: "Input",
  pOut: "Output",
  pLongFrom: "Long prompt from (tokens)",
  pInLong: "Input, long",
  pOutLong: "Output, long",
  pNote: "Note",
  pricesHint: "Checked against Anthropic's published prices on 03/Nov/2026. Thinking is billed as output.",
  keysTitle: "API keys",
  keyUser: "Key for people's calls",
  keySystem: "Key for portal jobs",
  keyShared: "Shared key",
  keyYes: "set",
  keyNo: "not set — the shared key is used",
  testNote: "Test rooms left out: {{list}}",
  unknown: "(unknown)",
  effortTitle: "Model and effort per feature",
  effortHint: "Each feature starts on Haiku, moves to Sonnet only when the answer needs more steps, and uses Opus only through Deeper analysis. Effort is how hard the model thinks before answering: thinking is billed as output, so short jobs run at low. A changed cell is marked; choose the dash to go back to the portal's setting.",
  eFeature: "Feature",
  eUsed: "Used (period)",
  eModelDefault: "default ({{l}})",
  eChanged: "changed",
  eSaved: "Saved — new calls use it within 5 minutes",
  lv_low: "low",
  lv_medium: "medium",
  lv_high: "high",
  lv_xhigh: "extra high",
  lv_max: "max",
  tourTodayT: "Today against the cap",
  tourTodayB: "The people's spend today against the daily cap — green, amber from 50%, red from 80% — and the portal jobs' own budget beside it. It resets at midnight Vietnam time.",
  tourPeopleT: "Each person",
  tourPeopleB: "Who has used AI today, against their own cap, and how many Deeper analysis runs they have used.",
  tourFilterT: "Filter and group",
  tourFilterB: "Choose a period and narrow by entity, department, person, feature or model; the chart and the table below follow. Group the table the way you want to read it.",
  tourSettingsT: "Caps, effort and prices",
  tourSettingsB: "Open this to change the daily caps, how hard each feature thinks (effort), and the model prices.",
  colAction: "Action",
  capSet: "Set cap",
  capDlgTitle: "Daily cap — {{name}}",
  capOwn: "Own daily cap (USD)",
  capOwnHint: "Leave empty to use the common cap (USD {{v}}).",
  capExtra: "Extra for today only (USD)",
  capExtraHint: "Added on top for today; it lapses at midnight.",
  cancel: "Cancel",
  ownTag: "own cap",
  personCapsTitle: "Per-person caps",
  personCapsHint: "A person with a cap of their own uses it every day instead of the common one.",
  addPerson: "Give a person their own cap…",
  colCapOwn: "Own cap",
  colExtra: "Extra today",
  edit: "Edit",
  toCommon: "Back to common",
  nonePersonal: "Everyone uses the common cap.",
  extraToday: "+USD {{v}} today only (cap USD {{cap}})",
  feat_assistant: "Catchy question",
  feat_assistant_deep: "Catchy — deeper analysis",
  feat_assistant_suggest: "Catchy suggested questions",
  feat_hub_ask: "AI Hub question",
  feat_hub_translate: "Translation",
  feat_gcc_side: "Group chat — Catchy follows",
  feat_gcc_interpret: "Group chat — interpretation",
  feat_gcc_digest: "Group chat — issues summary",
  feat_gcc_mention: "Group chat — @Catchy",
  feat_chat_greeting: "Chat interpretation & greeting",
  feat_project_status: "Project status line",
  feat_task_inbox: "System Project suggestions",
  feat_docs_part_summary: "Document part summaries",
  feat_docs_change_note: "Document 'what changed'",
  feat_insight_sales: "Sales Report summary",
  feat_insight_explorer: "Data Explorer summary",
  feat_catchy_report: "Catchy 16:00 report",
  feat_output_check: "Daily Output check",
  feat_sct_explain: "SCT explanation",
  feat_cw_translate: "Sales Data Load translation",
  feat_dc_name_match: "Name matching",
  feat_dc_remark_state: "Remark reading",
  feat_model_watch: "Model check",
};
const ko = {
  nav: "AI 사용량",
  title: "AI 사용량",
  sub: "포털 AI 비용, 누가·무엇이 쓰는지, 오늘 한도까지 얼마나 남았는지. 관리자 전용.",
  env_production: "운영",
  env_staging: "스테이징(테스트)",
  env_all: "두 서버 모두",
  todayTitle: "오늘",
  capLine: "USD {{spent}} / {{cap}} — {{pct}}%",
  resetIn: "{{h}}시간 {{m}}분 후 초기화 (베트남 시간 00:00)",
  peopleCap: "전체 조직",
  systemCap: "포털 자체 작업(보고서, 요약)",
  stopsAt: "한도에 도달하면 자정까지 모든 사용자의 AI가 멈춥니다. 자체 작업은 별도 예산을 씁니다.",
  cardMonth: "이번 달",
  cardVsLast: "지난달 같은 날까지 대비: {{v}}",
  cardLastMonth: "지난달: USD {{v}}",
  cardQuestions: "이번 달 질문 수",
  cardQVs: "지난달 같은 날까지: {{v}}",
  cardToday: "오늘 호출 수",
  personToday: "오늘 사용자별",
  colPerson: "사용자",
  colEntity: "법인",
  colDept: "부서",
  colToday: "오늘",
  colOwnCap: "개인 한도",
  colCalls: "호출",
  colDeep: "심층 분석",
  deepUsed: "{{limit}}회 중 {{n}}회",
  deepAdmin: "{{n}}회 · 제한 없음",
  noneToday: "오늘 AI를 사용한 사람이 없습니다.",
  trendTitle: "일별 비용",
  capRef: "일일 한도",
  period: "기간",
  p_today: "오늘",
  p_week: "이번 주",
  p_month: "이번 달",
  p_last: "지난달",
  p_custom: "직접 지정",
  dfrom: "시작",
  dto: "끝",
  fEntity: "법인",
  fDept: "부서",
  fPerson: "사용자",
  fFeature: "기능",
  fModel: "모델",
  all: "전체",
  clear: "필터 지우기",
  system: "SYSTEM(포털 작업)",
  groupBy: "묶기",
  g_person: "사용자",
  g_entity: "법인",
  g_dept: "부서",
  g_feature: "기능",
  g_model: "모델",
  g_day: "일",
  colName: "이름",
  colTin: "입력 토큰",
  colTout: "출력 토큰",
  colUsd: "USD",
  colShare: "비중",
  total: "합계",
  noRows: "이 기간에는 AI 사용이 없습니다.",
  settings: "설정 — 한도, 모델 가격, API 키",
  capsTitle: "일일 한도",
  capUsers: "전체 조직(USD)",
  capPerson: "1인당(USD)",
  capSystem: "포털 작업(USD)",
  capOpus: "1인 1일 심층 분석 횟수",
  save: "저장",
  saved: "저장됨",
  pricesTitle: "모델 가격(백만 토큰당 USD)",
  pModel: "모델",
  pIn: "입력",
  pOut: "출력",
  pLongFrom: "긴 프롬프트 기준(토큰)",
  pInLong: "입력(긴 프롬프트)",
  pOutLong: "출력(긴 프롬프트)",
  pNote: "메모",
  pricesHint: "2026-11-03 Anthropic 공시 가격과 대조했습니다. 생각(thinking)은 출력으로 과금됩니다.",
  keysTitle: "API 키",
  keyUser: "사용자 호출용 키",
  keySystem: "포털 작업용 키",
  keyShared: "공용 키",
  keyYes: "설정됨",
  keyNo: "미설정 — 공용 키 사용",
  testNote: "제외된 테스트 방: {{list}}",
  unknown: "(알 수 없음)",
  effortTitle: "기능별 모델과 effort",
  effortHint: "각 기능은 Haiku로 시작해 답에 단계가 더 필요할 때만 Sonnet으로 넘어가며, Opus는 심층 분석에서만 씁니다. effort는 답하기 전에 모델이 생각하는 정도입니다. 생각은 출력으로 과금되므로 짧은 작업은 low로 돌립니다. 바꾼 칸은 표시되며, 대시를 고르면 포털 기본 설정으로 돌아갑니다.",
  eFeature: "기능",
  eUsed: "사용(기간)",
  eModelDefault: "기본값 ({{l}})",
  eChanged: "변경됨",
  eSaved: "저장됨 — 5분 안에 새 호출부터 적용",
  lv_low: "low",
  lv_medium: "medium",
  lv_high: "high",
  lv_xhigh: "extra high",
  lv_max: "max",
  tourTodayT: "오늘 한도 대비",
  tourTodayB: "오늘 사용자 비용을 일일 한도와 비교합니다 — 녹색, 50%부터 주황, 80%부터 빨강. 옆은 포털 작업의 별도 예산입니다. 베트남 시간 자정에 초기화됩니다.",
  tourPeopleT: "사용자별",
  tourPeopleB: "오늘 AI를 쓴 사람, 개인 한도 대비 사용량, 사용한 심층 분석 횟수.",
  tourFilterT: "필터와 묶기",
  tourFilterB: "기간을 고르고 법인·부서·사용자·기능·모델로 좁히면 아래 차트와 표가 따라갑니다. 표는 원하는 기준으로 묶을 수 있습니다.",
  tourSettingsT: "한도, effort, 가격",
  tourSettingsB: "여기를 열어 일일 한도, 기능별 생각 정도(effort), 모델 가격을 바꿉니다.",
  colAction: "작업",
  capSet: "한도 설정",
  capDlgTitle: "일일 한도 — {{name}}",
  capOwn: "개인 일일 한도(USD)",
  capOwnHint: "비워 두면 공통 한도(USD {{v}})를 씁니다.",
  capExtra: "오늘만 추가(USD)",
  capExtraHint: "오늘만 더해지며 자정에 사라집니다.",
  cancel: "취소",
  ownTag: "개인 한도",
  personCapsTitle: "사용자별 한도",
  personCapsHint: "개인 한도가 있는 사람은 공통 한도 대신 매일 그 한도를 씁니다.",
  addPerson: "개인 한도를 줄 사람 선택…",
  colCapOwn: "개인 한도",
  colExtra: "오늘 추가",
  edit: "수정",
  toCommon: "공통 한도로",
  nonePersonal: "모두 공통 한도를 씁니다.",
  extraToday: "오늘만 +USD {{v}} (한도 USD {{cap}})",
  feat_assistant: "Catchy 질문",
  feat_assistant_deep: "Catchy 심층 분석",
  feat_assistant_suggest: "Catchy 추천 질문",
  feat_hub_ask: "AI Hub 질문",
  feat_hub_translate: "번역",
  feat_gcc_side: "그룹 채팅 — Catchy 참여",
  feat_gcc_interpret: "그룹 채팅 — 통역",
  feat_gcc_digest: "그룹 채팅 — 이슈 요약",
  feat_gcc_mention: "그룹 채팅 — @Catchy",
  feat_chat_greeting: "채팅 해석·인사",
  feat_project_status: "프로젝트 상태 문구",
  feat_task_inbox: "System Project 제안",
  feat_docs_part_summary: "문서 부분 요약",
  feat_docs_change_note: "문서 변경 내용",
  feat_insight_sales: "Sales Report 요약",
  feat_insight_explorer: "Data Explorer 요약",
  feat_catchy_report: "Catchy 16:00 보고서",
  feat_output_check: "Daily Output 점검",
  feat_sct_explain: "SCT 설명",
  feat_cw_translate: "Sales Data Load 번역",
  feat_dc_name_match: "이름 매칭",
  feat_dc_remark_state: "비고 판독",
  feat_model_watch: "모델 점검",
};
const vi = {
  nav: "Chi phí AI",
  title: "Chi phí AI",
  sub: "Chi phí AI của portal, ai và tính năng nào đang dùng, hôm nay còn cách trần bao nhiêu. Chỉ Admin.",
  env_production: "Production",
  env_staging: "Staging (thử)",
  env_all: "Cả hai server",
  todayTitle: "Hôm nay",
  capLine: "USD {{spent}} / {{cap}} — {{pct}}%",
  resetIn: "Còn {{h}} giờ {{m}} phút nữa reset (00:00 giờ Việt Nam)",
  peopleCap: "Toàn tổ chức",
  systemCap: "Job của portal (báo cáo, tóm tắt)",
  stopsAt: "Chạm trần thì AI dừng với mọi người tới nửa đêm; các job có ngân sách riêng.",
  cardMonth: "Tháng này",
  cardVsLast: "so với tháng trước cùng ngày: {{v}}",
  cardLastMonth: "Tháng trước: USD {{v}}",
  cardQuestions: "Câu hỏi tháng này",
  cardQVs: "tháng trước cùng ngày: {{v}}",
  cardToday: "Lượt gọi hôm nay",
  personToday: "Từng người hôm nay",
  colPerson: "Người dùng",
  colEntity: "Pháp nhân",
  colDept: "Phòng ban",
  colToday: "Hôm nay",
  colOwnCap: "Hạn mức riêng",
  colCalls: "Lượt gọi",
  colDeep: "Phân tích sâu",
  deepUsed: "{{n}} / {{limit}}",
  deepAdmin: "{{n}} · không giới hạn",
  noneToday: "Hôm nay chưa ai dùng AI.",
  trendTitle: "Chi phí theo ngày",
  capRef: "Trần ngày",
  period: "Kỳ",
  p_today: "Hôm nay",
  p_week: "Tuần này",
  p_month: "Tháng này",
  p_last: "Tháng trước",
  p_custom: "Tự chọn",
  dfrom: "Từ",
  dto: "Đến",
  fEntity: "Pháp nhân",
  fDept: "Phòng ban",
  fPerson: "Người dùng",
  fFeature: "Tính năng",
  fModel: "Model",
  all: "Tất cả",
  clear: "Xoá bộ lọc",
  system: "SYSTEM (job của portal)",
  groupBy: "Gom theo",
  g_person: "Người dùng",
  g_entity: "Pháp nhân",
  g_dept: "Phòng ban",
  g_feature: "Tính năng",
  g_model: "Model",
  g_day: "Ngày",
  colName: "Tên",
  colTin: "Token vào",
  colTout: "Token ra",
  colUsd: "USD",
  colShare: "Tỷ lệ",
  total: "Tổng",
  noRows: "Không có lượt dùng AI trong kỳ này.",
  settings: "Cài đặt — trần, giá model, API key",
  capsTitle: "Trần mỗi ngày",
  capUsers: "Toàn tổ chức (USD)",
  capPerson: "Mỗi người (USD)",
  capSystem: "Job của portal (USD)",
  capOpus: "Lượt phân tích sâu mỗi người mỗi ngày",
  save: "Lưu",
  saved: "Đã lưu",
  pricesTitle: "Giá model (USD mỗi triệu token)",
  pModel: "Model",
  pIn: "Vào",
  pOut: "Ra",
  pLongFrom: "Prompt dài từ (token)",
  pInLong: "Vào, prompt dài",
  pOutLong: "Ra, prompt dài",
  pNote: "Ghi chú",
  pricesHint: "Đã đối chiếu với giá công bố của Anthropic ngày 03/11/2026. Phần suy nghĩ (thinking) tính như token ra.",
  keysTitle: "API key",
  keyUser: "Key cho lượt gọi của người dùng",
  keySystem: "Key cho job của portal",
  keyShared: "Key dùng chung",
  keyYes: "đã có",
  keyNo: "chưa có — dùng key chung",
  testNote: "Đã loại phòng test: {{list}}",
  unknown: "(không rõ)",
  effortTitle: "Model và effort theo tính năng",
  effortHint: "Mỗi tính năng chạy Haiku trước, chỉ chuyển sang Sonnet khi câu trả lời cần nhiều bước hơn, và chỉ dùng Opus qua Phân tích sâu. Effort là mức model suy nghĩ trước khi trả lời: phần suy nghĩ tính tiền như token ra, nên việc ngắn chạy ở low. Ô đã đổi được đánh dấu; chọn dấu gạch để quay về cài đặt của portal.",
  eFeature: "Tính năng",
  eUsed: "Đã dùng (trong kỳ)",
  eModelDefault: "mặc định ({{l}})",
  eChanged: "đã đổi",
  eSaved: "Đã lưu — lượt gọi mới áp dụng trong vòng 5 phút",
  lv_low: "low",
  lv_medium: "medium",
  lv_high: "high",
  lv_xhigh: "extra high",
  lv_max: "max",
  tourTodayT: "Hôm nay so với trần",
  tourTodayB: "Chi phí của người dùng hôm nay so với trần ngày — xanh, vàng từ 50%, đỏ từ 80% — bên cạnh là ngân sách riêng của job portal. Reset lúc nửa đêm giờ Việt Nam.",
  tourPeopleT: "Từng người",
  tourPeopleB: "Ai đã dùng AI hôm nay, so với hạn mức riêng, và đã dùng bao nhiêu lượt Phân tích sâu.",
  tourFilterT: "Lọc và gom",
  tourFilterB: "Chọn kỳ và lọc theo pháp nhân, phòng ban, người dùng, tính năng hoặc model; biểu đồ và bảng bên dưới đi theo. Bảng có thể gom theo nhiều cách.",
  tourSettingsT: "Trần, effort và giá",
  tourSettingsB: "Mở phần này để đổi trần mỗi ngày, mức suy nghĩ của từng tính năng (effort) và giá model.",
  colAction: "Thao tác",
  capSet: "Đặt hạn mức",
  capDlgTitle: "Hạn mức ngày — {{name}}",
  capOwn: "Hạn mức riêng mỗi ngày (USD)",
  capOwnHint: "Để trống thì dùng hạn mức chung (USD {{v}}).",
  capExtra: "Cộng thêm riêng hôm nay (USD)",
  capExtraHint: "Chỉ cộng trong hôm nay, qua nửa đêm tự hết.",
  cancel: "Huỷ",
  ownTag: "hạn mức riêng",
  personCapsTitle: "Hạn mức riêng từng người",
  personCapsHint: "Người có hạn mức riêng sẽ dùng mức đó mỗi ngày thay cho hạn mức chung.",
  addPerson: "Chọn người để đặt hạn mức riêng…",
  colCapOwn: "Hạn mức riêng",
  colExtra: "Cộng thêm hôm nay",
  edit: "Sửa",
  toCommon: "Về hạn mức chung",
  nonePersonal: "Mọi người đang dùng hạn mức chung.",
  extraToday: "+USD {{v}} riêng hôm nay (hạn mức USD {{cap}})",
  feat_assistant: "Câu hỏi Catchy",
  feat_assistant_deep: "Catchy — phân tích sâu",
  feat_assistant_suggest: "Catchy gợi ý câu hỏi",
  feat_hub_ask: "Câu hỏi AI Hub",
  feat_hub_translate: "Dịch",
  feat_gcc_side: "Group chat — Catchy theo dõi",
  feat_gcc_interpret: "Group chat — phiên dịch",
  feat_gcc_digest: "Group chat — tóm tắt vấn đề",
  feat_gcc_mention: "Group chat — @Catchy",
  feat_chat_greeting: "Diễn giải & chào trong chat",
  feat_project_status: "Dòng trạng thái project",
  feat_task_inbox: "Gợi ý System Project",
  feat_docs_part_summary: "Tóm tắt từng phần tài liệu",
  feat_docs_change_note: "Tài liệu — điều gì thay đổi",
  feat_insight_sales: "Tóm tắt Sales Report",
  feat_insight_explorer: "Tóm tắt Data Explorer",
  feat_catchy_report: "Báo cáo Catchy 16:00",
  feat_output_check: "Kiểm Daily Output",
  feat_sct_explain: "Giải thích SCT",
  feat_cw_translate: "Dịch Sales Data Load",
  feat_dc_name_match: "Ghép tên",
  feat_dc_remark_state: "Đọc ghi chú",
  feat_model_watch: "Kiểm model",
};
const zh = {
  nav: "AI 用量",
  title: "AI 用量",
  sub: "门户 AI 的费用、谁和什么在用，以及今天离上限还有多远。仅限管理员。",
  env_production: "生产",
  env_staging: "测试服务器",
  env_all: "两台服务器",
  todayTitle: "今天",
  capLine: "USD {{spent}} / {{cap}} — {{pct}}%",
  resetIn: "{{h}} 小时 {{m}} 分钟后重置（越南时间 00:00）",
  peopleCap: "全组织",
  systemCap: "门户自身任务（报告、摘要）",
  stopsAt: "达到上限后，所有用户的 AI 停到午夜；任务有自己的预算。",
  cardMonth: "本月",
  cardVsLast: "与上月同日相比：{{v}}",
  cardLastMonth: "上月：USD {{v}}",
  cardQuestions: "本月提问数",
  cardQVs: "上月同日：{{v}}",
  cardToday: "今天调用次数",
  personToday: "今天每个人",
  colPerson: "用户",
  colEntity: "法人",
  colDept: "部门",
  colToday: "今天",
  colOwnCap: "个人上限",
  colCalls: "调用",
  colDeep: "深入分析",
  deepUsed: "{{n}} / {{limit}}",
  deepAdmin: "{{n}} · 无限制",
  noneToday: "今天还没有人使用 AI。",
  trendTitle: "每日费用",
  capRef: "每日上限",
  period: "期间",
  p_today: "今天",
  p_week: "本周",
  p_month: "本月",
  p_last: "上月",
  p_custom: "自定义",
  dfrom: "从",
  dto: "到",
  fEntity: "法人",
  fDept: "部门",
  fPerson: "用户",
  fFeature: "功能",
  fModel: "模型",
  all: "全部",
  clear: "清除筛选",
  system: "SYSTEM（门户任务）",
  groupBy: "分组",
  g_person: "用户",
  g_entity: "法人",
  g_dept: "部门",
  g_feature: "功能",
  g_model: "模型",
  g_day: "日",
  colName: "名称",
  colTin: "输入 token",
  colTout: "输出 token",
  colUsd: "USD",
  colShare: "占比",
  total: "合计",
  noRows: "此期间没有 AI 使用。",
  settings: "设置 — 上限、模型价格、API 密钥",
  capsTitle: "每日上限",
  capUsers: "全组织（USD）",
  capPerson: "每人（USD）",
  capSystem: "门户任务（USD）",
  capOpus: "每人每天深入分析次数",
  save: "保存",
  saved: "已保存",
  pricesTitle: "模型价格（每百万 token USD）",
  pModel: "模型",
  pIn: "输入",
  pOut: "输出",
  pLongFrom: "长提示起点（token）",
  pInLong: "输入（长提示）",
  pOutLong: "输出（长提示）",
  pNote: "备注",
  pricesHint: "已于 2026-11-03 与 Anthropic 公布价格核对。思考（thinking）按输出计费。",
  keysTitle: "API 密钥",
  keyUser: "用户调用的密钥",
  keySystem: "门户任务的密钥",
  keyShared: "共用密钥",
  keyYes: "已设置",
  keyNo: "未设置 — 使用共用密钥",
  testNote: "已排除的测试房间：{{list}}",
  unknown: "（未知）",
  effortTitle: "各功能的模型和 effort",
  effortHint: "每个功能先用 Haiku，只有回答需要更多步骤时才转到 Sonnet，Opus 只通过深入分析使用。effort 是模型回答前思考的程度：思考按输出计费，所以简短任务用 low。已修改的格子会标出；选短横线即恢复门户的设置。",
  eFeature: "功能",
  eUsed: "使用（期间）",
  eModelDefault: "默认（{{l}}）",
  eChanged: "已修改",
  eSaved: "已保存 — 5 分钟内新调用生效",
  lv_low: "low",
  lv_medium: "medium",
  lv_high: "high",
  lv_xhigh: "extra high",
  lv_max: "max",
  tourTodayT: "今天与上限",
  tourTodayB: "今天用户的费用与每日上限对比 — 绿色，50% 起橙色，80% 起红色 — 旁边是门户任务的独立预算。越南时间午夜重置。",
  tourPeopleT: "每个人",
  tourPeopleB: "今天谁用了 AI、与个人上限相比用了多少，以及用了几次深入分析。",
  tourFilterT: "筛选和分组",
  tourFilterB: "选择期间，按法人、部门、用户、功能或模型缩小范围；下方图表和表格随之变化。表格可按需要分组。",
  tourSettingsT: "上限、effort 和价格",
  tourSettingsB: "打开这里修改每日上限、各功能的思考程度（effort）和模型价格。",
  colAction: "操作",
  capSet: "设置上限",
  capDlgTitle: "每日上限 — {{name}}",
  capOwn: "个人每日上限（USD）",
  capOwnHint: "留空则使用通用上限（USD {{v}}）。",
  capExtra: "仅今天追加（USD）",
  capExtraHint: "仅今天追加，午夜后失效。",
  cancel: "取消",
  ownTag: "个人上限",
  personCapsTitle: "按人设置上限",
  personCapsHint: "有个人上限的人每天使用该上限，而不是通用上限。",
  addPerson: "选择要设置个人上限的人…",
  colCapOwn: "个人上限",
  colExtra: "今天追加",
  edit: "编辑",
  toCommon: "恢复通用上限",
  nonePersonal: "所有人都使用通用上限。",
  extraToday: "仅今天 +USD {{v}}（上限 USD {{cap}}）",
  feat_assistant: "Catchy 提问",
  feat_assistant_deep: "Catchy 深入分析",
  feat_assistant_suggest: "Catchy 推荐问题",
  feat_hub_ask: "AI Hub 提问",
  feat_hub_translate: "翻译",
  feat_gcc_side: "群聊 — Catchy 跟随",
  feat_gcc_interpret: "群聊 — 口译",
  feat_gcc_digest: "群聊 — 问题摘要",
  feat_gcc_mention: "群聊 — @Catchy",
  feat_chat_greeting: "聊天解读与问候",
  feat_project_status: "项目状态说明",
  feat_task_inbox: "System Project 建议",
  feat_docs_part_summary: "文档分段摘要",
  feat_docs_change_note: "文档变更说明",
  feat_insight_sales: "Sales Report 摘要",
  feat_insight_explorer: "Data Explorer 摘要",
  feat_catchy_report: "Catchy 16:00 报告",
  feat_output_check: "Daily Output 检查",
  feat_sct_explain: "SCT 说明",
  feat_cw_translate: "Sales Data Load 翻译",
  feat_dc_name_match: "名称匹配",
  feat_dc_remark_state: "备注识别",
  feat_model_watch: "模型检查",
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "nav": "Utilisation IA",
  "title": "Utilisation IA",
  "sub": "Ce que coûte l'IA du portail, qui l'utilise et pour quoi, et où en est la journée par rapport au plafond. Admin uniquement.",
  "env_production": "Production",
  "env_staging": "Staging (test)",
  "env_all": "Les deux serveurs",
  "todayTitle": "Aujourd'hui",
  "capLine": "USD {{spent}} sur {{cap}} — {{pct}}%",
  "resetIn": "Réinitialisation dans {{h}} h {{m}} min (00:00 heure du Vietnam)",
  "peopleCap": "Organisation entière",
  "systemCap": "Tâches propres au portail (rapports, résumés)",
  "stopsAt": "Au plafond, l'IA s'arrête pour tout le monde jusqu'à minuit ; les tâches conservent leur propre budget.",
  "cardMonth": "Ce mois-ci",
  "cardVsLast": "par rapport au mois dernier à la même date : {{v}}",
  "cardLastMonth": "Mois dernier : USD {{v}}",
  "cardQuestions": "Questions posées ce mois-ci",
  "cardQVs": "mois dernier à la même date : {{v}}",
  "cardToday": "Appels aujourd'hui",
  "personToday": "Chaque personne aujourd'hui",
  "colPerson": "Personne",
  "colEntity": "Entité",
  "colDept": "Département",
  "colToday": "Aujourd'hui",
  "colOwnCap": "Plafond personnel",
  "colCalls": "Appels",
  "colDeep": "Analyse approfondie",
  "deepUsed": "{{n}} sur {{limit}}",
  "deepAdmin": "{{n}} · sans limite",
  "noneToday": "Personne n'a utilisé l'IA aujourd'hui.",
  "trendTitle": "Dépenses quotidiennes",
  "capRef": "Plafond quotidien",
  "period": "Période",
  "p_today": "Aujourd'hui",
  "p_week": "Cette semaine",
  "p_month": "Ce mois-ci",
  "p_last": "Mois dernier",
  "p_custom": "Personnalisée",
  "dfrom": "Du",
  "dto": "Au",
  "fEntity": "Entité",
  "fDept": "Département",
  "fPerson": "Personne",
  "fFeature": "Fonctionnalité",
  "fModel": "Modèle",
  "all": "Tous",
  "clear": "Effacer les filtres",
  "system": "SYSTEM (tâches du portail)",
  "groupBy": "Regrouper par",
  "g_person": "Personne",
  "g_entity": "Entité",
  "g_dept": "Département",
  "g_feature": "Fonctionnalité",
  "g_model": "Modèle",
  "g_day": "Jour",
  "colName": "Nom",
  "colTin": "Tokens en entrée",
  "colTout": "Tokens en sortie",
  "colUsd": "USD",
  "colShare": "Part",
  "total": "Total",
  "noRows": "Aucune utilisation de l'IA sur cette période.",
  "settings": "Paramètres — plafonds, prix des modèles, clés API",
  "capsTitle": "Plafonds quotidiens",
  "capUsers": "Organisation entière (USD)",
  "capPerson": "Par personne (USD)",
  "capSystem": "Tâches du portail (USD)",
  "capOpus": "Analyses approfondies par personne et par jour",
  "save": "Enregistrer",
  "saved": "Enregistré",
  "pricesTitle": "Prix des modèles (USD par million de tokens)",
  "pModel": "Modèle",
  "pIn": "Entrée",
  "pOut": "Sortie",
  "pLongFrom": "Prompt long à partir de (tokens)",
  "pInLong": "Entrée, long",
  "pOutLong": "Sortie, long",
  "pNote": "Remarque",
  "pricesHint": "Vérifié par rapport aux prix publiés par Anthropic le 03/Nov/2026. La réflexion est facturée comme de la sortie.",
  "keysTitle": "Clés API",
  "keyUser": "Clé pour les appels des personnes",
  "keySystem": "Clé pour les tâches du portail",
  "keyShared": "Clé partagée",
  "keyYes": "définie",
  "keyNo": "non définie — la clé partagée est utilisée",
  "testNote": "Salles de test exclues : {{list}}",
  "unknown": "(inconnu)",
  "effortTitle": "Modèle et effort par fonctionnalité",
  "effortHint": "Chaque fonctionnalité démarre sur Haiku, passe à Sonnet uniquement quand la réponse demande plus d'étapes, et n'utilise Opus que via l'analyse approfondie. L'effort correspond à l'intensité de réflexion du modèle avant de répondre : la réflexion est facturée comme de la sortie, donc les tâches courtes tournent à un niveau bas. Une cellule modifiée est signalée ; choisissez le tiret pour revenir au réglage du portail.",
  "eFeature": "Fonctionnalité",
  "eUsed": "Utilisé (période)",
  "eModelDefault": "par défaut ({{l}})",
  "eChanged": "modifié",
  "eSaved": "Enregistré — les nouveaux appels l'utilisent d'ici 5 minutes",
  "lv_low": "low",
  "lv_medium": "medium",
  "lv_high": "high",
  "lv_xhigh": "extra high",
  "lv_max": "max",
  "tourTodayT": "Aujourd'hui par rapport au plafond",
  "tourTodayB": "Les dépenses des personnes aujourd'hui par rapport au plafond quotidien — vert, orange à partir de 50 %, rouge à partir de 80 % — et, à côté, le budget propre aux tâches du portail. Réinitialisation à minuit, heure du Vietnam.",
  "tourPeopleT": "Chaque personne",
  "tourPeopleB": "Qui a utilisé l'IA aujourd'hui, par rapport à son propre plafond, et combien d'analyses approfondies elle a utilisées.",
  "tourFilterT": "Filtrer et regrouper",
  "tourFilterB": "Choisissez une période et affinez par entité, département, personne, fonctionnalité ou modèle ; le graphique et le tableau ci-dessous suivent. Regroupez le tableau comme vous voulez le lire.",
  "tourSettingsT": "Plafonds, effort et prix",
  "tourSettingsB": "Ouvrez ceci pour modifier les plafonds quotidiens, l'intensité de réflexion de chaque fonctionnalité (effort) et les prix des modèles.",
  "colAction": "Action",
  "capSet": "Définir le plafond",
  "capDlgTitle": "Plafond quotidien — {{name}}",
  "capOwn": "Plafond quotidien personnel (USD)",
  "capOwnHint": "Laissez vide pour utiliser le plafond commun (USD {{v}}).",
  "capExtra": "Supplément pour aujourd'hui seulement (USD)",
  "capExtraHint": "Ajouté en plus pour aujourd'hui ; expire à minuit.",
  "cancel": "Annuler",
  "ownTag": "plafond personnel",
  "personCapsTitle": "Plafonds par personne",
  "personCapsHint": "Une personne ayant un plafond personnel l'utilise chaque jour à la place du plafond commun.",
  "addPerson": "Attribuer un plafond personnel à quelqu'un…",
  "colCapOwn": "Plafond personnel",
  "colExtra": "Supplément aujourd'hui",
  "edit": "Modifier",
  "toCommon": "Revenir au commun",
  "nonePersonal": "Tout le monde utilise le plafond commun.",
  "extraToday": "+USD {{v}} aujourd'hui seulement (plafond USD {{cap}})",
  "feat_assistant": "Question à Catchy",
  "feat_assistant_deep": "Catchy — analyse approfondie",
  "feat_assistant_suggest": "Questions suggérées par Catchy",
  "feat_hub_ask": "Question AI Hub",
  "feat_hub_translate": "Traduction",
  "feat_gcc_side": "Chat de groupe — Catchy suit",
  "feat_gcc_interpret": "Chat de groupe — interprétation",
  "feat_gcc_digest": "Chat de groupe — résumé des problèmes",
  "feat_gcc_mention": "Chat de groupe — @Catchy",
  "feat_chat_greeting": "Interprétation et message d'accueil du chat",
  "feat_project_status": "Ligne de statut du projet",
  "feat_task_inbox": "Suggestions System Project",
  "feat_docs_part_summary": "Résumés des parties de document",
  "feat_docs_change_note": "« Ce qui a changé » dans un document",
  "feat_insight_sales": "Résumé du Sales Report",
  "feat_insight_explorer": "Résumé de Data Explorer",
  "feat_catchy_report": "Rapport Catchy de 16:00",
  "feat_output_check": "Contrôle du Daily Output",
  "feat_sct_explain": "Explication SCT",
  "feat_cw_translate": "Traduction Sales Data Load",
  "feat_dc_name_match": "Rapprochement des noms",
  "feat_dc_remark_state": "Lecture des remarques",
  "feat_model_watch": "Vérification des modèles"
};
const ja = {
  "nav": "AI 利用状況",
  "title": "AI 利用状況",
  "sub": "ポータルの AI にかかる費用、利用者と用途、本日の上限までの残りを表示します。Admin のみ。",
  "env_production": "Production",
  "env_staging": "Staging（テスト）",
  "env_all": "両方のサーバー",
  "todayTitle": "本日",
  "capLine": "USD {{spent}} / {{cap}} — {{pct}}%",
  "resetIn": "{{h}} 時間 {{m}} 分後にリセット（ベトナム時間 00:00）",
  "peopleCap": "組織全体",
  "systemCap": "ポータル自身のジョブ（レポート、要約）",
  "stopsAt": "上限に達すると、深夜 0 時まで全員の AI が停止します。ジョブは独自の予算を保持します。",
  "cardMonth": "今月",
  "cardVsLast": "前月の同日まで比：{{v}}",
  "cardLastMonth": "前月：USD {{v}}",
  "cardQuestions": "今月の質問数",
  "cardQVs": "前月の同日まで：{{v}}",
  "cardToday": "本日の呼び出し数",
  "personToday": "本日のユーザー別",
  "colPerson": "ユーザー",
  "colEntity": "エンティティ",
  "colDept": "部門",
  "colToday": "本日",
  "colOwnCap": "個別の上限",
  "colCalls": "呼び出し数",
  "colDeep": "詳細分析",
  "deepUsed": "{{n}} / {{limit}}",
  "deepAdmin": "{{n}} · 上限なし",
  "noneToday": "本日 AI を利用した人はいません。",
  "trendTitle": "日別の利用額",
  "capRef": "1 日の上限",
  "period": "期間",
  "p_today": "本日",
  "p_week": "今週",
  "p_month": "今月",
  "p_last": "前月",
  "p_custom": "カスタム",
  "dfrom": "開始",
  "dto": "終了",
  "fEntity": "エンティティ",
  "fDept": "部門",
  "fPerson": "ユーザー",
  "fFeature": "機能",
  "fModel": "モデル",
  "all": "すべて",
  "clear": "フィルターをクリア",
  "system": "SYSTEM（ポータルのジョブ）",
  "groupBy": "グループ化",
  "g_person": "ユーザー",
  "g_entity": "エンティティ",
  "g_dept": "部門",
  "g_feature": "機能",
  "g_model": "モデル",
  "g_day": "日",
  "colName": "名前",
  "colTin": "入力トークン",
  "colTout": "出力トークン",
  "colUsd": "USD",
  "colShare": "構成比",
  "total": "合計",
  "noRows": "この期間の AI 利用はありません。",
  "settings": "設定 — 上限、モデル価格、API キー",
  "capsTitle": "1 日あたりの上限",
  "capUsers": "組織全体（USD）",
  "capPerson": "ユーザーごと（USD）",
  "capSystem": "ポータルのジョブ（USD）",
  "capOpus": "ユーザー 1 人あたりの 1 日の詳細分析回数",
  "save": "保存",
  "saved": "保存しました",
  "pricesTitle": "モデル価格（100 万トークンあたりの USD）",
  "pModel": "モデル",
  "pIn": "入力",
  "pOut": "出力",
  "pLongFrom": "長いプロンプトの基準（トークン）",
  "pInLong": "入力（長文）",
  "pOutLong": "出力（長文）",
  "pNote": "備考",
  "pricesHint": "03/Nov/2026 時点で Anthropic の公開価格と照合済みです。思考は出力として課金されます。",
  "keysTitle": "API キー",
  "keyUser": "ユーザーの呼び出し用キー",
  "keySystem": "ポータルのジョブ用キー",
  "keyShared": "共有キー",
  "keyYes": "設定済み",
  "keyNo": "未設定 — 共有キーを使用します",
  "testNote": "除外したテストルーム：{{list}}",
  "unknown": "（不明）",
  "effortTitle": "機能ごとのモデルと思考の深さ",
  "effortHint": "各機能は Haiku で開始し、回答により多くのステップが必要な場合にのみ Sonnet に切り替わり、Opus は詳細分析でのみ使用します。思考の深さ（effort）とは、モデルが回答前にどれだけ深く考えるかを指します。思考は出力として課金されるため、短いジョブは低で実行します。変更したセルには印が付きます。ダッシュを選ぶとポータルの設定に戻ります。",
  "eFeature": "機能",
  "eUsed": "使用量（期間）",
  "eModelDefault": "デフォルト（{{l}}）",
  "eChanged": "変更済み",
  "eSaved": "保存しました — 新しい呼び出しは 5 分以内に反映されます",
  "lv_low": "low",
  "lv_medium": "medium",
  "lv_high": "high",
  "lv_xhigh": "extra high",
  "lv_max": "max",
  "tourTodayT": "本日の上限に対する状況",
  "tourTodayB": "本日のユーザーの利用額を 1 日の上限と比較して表示します（緑、50% から橙、80% から赤）。隣にはポータルのジョブ独自の予算も表示します。ベトナム時間の 0 時にリセットされます。",
  "tourPeopleT": "ユーザー別",
  "tourPeopleB": "本日 AI を利用した人を、それぞれの上限と比較して表示します。詳細分析の利用回数も確認できます。",
  "tourFilterT": "絞り込みとグループ化",
  "tourFilterB": "期間を選び、エンティティ、部門、ユーザー、機能、モデルで絞り込みます。下のグラフと表も連動します。表は読みやすいようにグループ化できます。",
  "tourSettingsT": "上限、思考の深さ、価格",
  "tourSettingsB": "1 日の上限、各機能の思考の深さ（effort）、モデル価格を変更するには、ここを開きます。",
  "colAction": "操作",
  "capSet": "上限を設定",
  "capDlgTitle": "1 日の上限 — {{name}}",
  "capOwn": "個別の 1 日の上限（USD）",
  "capOwnHint": "空欄にすると共通の上限（USD {{v}}）が使われます。",
  "capExtra": "本日限りの追加分（USD）",
  "capExtraHint": "本日分に上乗せされます。0 時に失効します。",
  "cancel": "キャンセル",
  "ownTag": "個別の上限",
  "personCapsTitle": "ユーザー別の上限",
  "personCapsHint": "個別の上限を持つユーザーは、共通の上限の代わりにその上限を毎日使用します。",
  "addPerson": "ユーザーに個別の上限を設定…",
  "colCapOwn": "個別の上限",
  "colExtra": "本日の追加分",
  "edit": "編集",
  "toCommon": "共通に戻す",
  "nonePersonal": "全員が共通の上限を使用しています。",
  "extraToday": "本日限り +USD {{v}}（上限 USD {{cap}}）",
  "feat_assistant": "Catchy への質問",
  "feat_assistant_deep": "Catchy — 詳細分析",
  "feat_assistant_suggest": "Catchy の質問候補",
  "feat_hub_ask": "AI Hub への質問",
  "feat_hub_translate": "翻訳",
  "feat_gcc_side": "グループチャット — Catchy の追跡",
  "feat_gcc_interpret": "グループチャット — 通訳",
  "feat_gcc_digest": "グループチャット — 問題の要約",
  "feat_gcc_mention": "グループチャット — @Catchy",
  "feat_chat_greeting": "チャットの通訳とあいさつ",
  "feat_project_status": "プロジェクトのステータス行",
  "feat_task_inbox": "System Project の提案",
  "feat_docs_part_summary": "ドキュメントのパート要約",
  "feat_docs_change_note": "ドキュメントの「変更点」",
  "feat_insight_sales": "Sales Report の要約",
  "feat_insight_explorer": "Data Explorer の要約",
  "feat_catchy_report": "Catchy 16:00 レポート",
  "feat_output_check": "Daily Output のチェック",
  "feat_sct_explain": "SCT の説明",
  "feat_cw_translate": "Sales Data Load の翻訳",
  "feat_dc_name_match": "名前の照合",
  "feat_dc_remark_state": "備考の読み取り",
  "feat_model_watch": "モデルのチェック"
};

const dictionary = { ns: 'xAiUse', en, ko, vi, zh, fr, ja };
export default dictionary;
